import { lastValueFrom } from 'rxjs';
import { VoucherTransaction } from 'src/app/interfaces/voucher/voucher';

import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, NgModel } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router } from '@angular/router';

import { StatusType } from '../common/enums/status-type-enum';
import {
  AdditionaFileRequestStatus,
  AnnouncementStatus,
  BeneficiaryStatus,
  GeneralStatus,
  KycStatus,
  RemitterStatus,
  TransactionStatus,
  VoucherRemitterStatus,
  VoucherStatus,
} from '../common/status';
import { Currency } from '../interfaces/currency/currency';
import { MyInfoPassType } from '../interfaces/my-info/my-info-pass-type';
import { PredefinedOptions } from '../interfaces/predefined-options';
import { ErrorResponse } from '../interfaces/response/error-response';
import { SiteSetting } from '../interfaces/site-setting';
import { CoreService } from './core.service';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  err: ErrorResponse | undefined;

  countryList: PredefinedOptions[] | undefined;
  incomeRangeList: PredefinedOptions[] | undefined;
  sourceOfFundList: PredefinedOptions[] | undefined;
  occupationList: PredefinedOptions[] | undefined;
  vndPaymentModeList: PredefinedOptions[] | undefined;
  vndBankNameList: PredefinedOptions[] | undefined;
  vndDistrictList: PredefinedOptions[] | undefined;
  cnyBankNameList: PredefinedOptions[] | undefined;

  passTypeList: MyInfoPassType[] | undefined;
  currencyList: Currency[] | undefined;

  constructor(private router: Router, private coreService: CoreService) {}

  getFullName(
    firstName: string,
    middleName: string | undefined,
    lastName: string
  ): string {
    if (middleName) {
      return `${firstName} ${middleName} ${lastName}`;
    }
    if (lastName) {
      return `${firstName} ${lastName}`;
    }
    return `${firstName}`;
  }

  getGender(gender: string): string {
    switch (gender) {
      case 'm':
        return 'Male';
      case 'f':
        return 'Female';
    }
    return 'Unknown';
  }

  getStatusDesc(statusType: StatusType, status: string): string {
    var statusList: any;
    switch (statusType) {
      case StatusType.USER:
      case StatusType.EXCHANGE_RATE:
      case StatusType.SERVICE:
      case StatusType.CURRENCY:
      case StatusType.FAQ:
      case StatusType.SLIDER:
        statusList = GeneralStatus;
        break;
      case StatusType.BENEFICIARY:
        statusList = BeneficiaryStatus;
        break;
      case StatusType.REMITTER:
        statusList = RemitterStatus;
        break;
      case StatusType.ADDITIONAL_FILE_REQUEST:
        statusList = AdditionaFileRequestStatus;
        break;
      case StatusType.KYC_SUBMISSIONS:
        statusList = KycStatus;
        break;
      case StatusType.TRANSACTION:
        statusList = TransactionStatus;
        break;
      case StatusType.VOUCHER:
        statusList = VoucherStatus;
        break;
      case StatusType.VOUCHER_REMITTER:
        statusList = VoucherRemitterStatus;
        break;
      case StatusType.ANNOUCEMENT:
        statusList = AnnouncementStatus;
        break;
    }
    // console.log(statusList);
    for (let i = 0; i < statusList.length; i++) {
      const s = statusList[i];
      if (s.value == status) {
        return s.description;
      }
    }
    return 'Unknown';
  }

  async getPredefinedOptionList(
    type: string,
    param: HttpParams
  ): Promise<PredefinedOptions[] | undefined> {
    const req = this.coreService.getRequest(`misc/predefined-options`, param);
    const res = await lastValueFrom(req);
    console.log(`get predefined_options res type=${type}`);
    console.log(res);
    if (res.data.predefined_options.data) {
      if (type == 'country') {
        this.countryList = res.data.predefined_options.data;
        if (this.countryList) {
          // Filter out "SINGAPORE" and remove it from the countries array
          const singaporeIndex = this.countryList.findIndex(
            (country) => country.option_value === 'SINGAPORE'
          );
          if (singaporeIndex !== -1) {
            const singaporeCountry = this.countryList.splice(
              singaporeIndex,
              1
            )[0];
            // Prepend "SINGAPORE" to the beginning of the countries array
            this.countryList.unshift(singaporeCountry);
          }
        }
        return this.countryList;
      } else if (type == 'income_range') {
        this.incomeRangeList = res.data.predefined_options.data;
        return this.incomeRangeList;
      } else if (type == 'source_of_fund') {
        this.sourceOfFundList = res.data.predefined_options.data;
        return this.sourceOfFundList;
      } else if (type == 'occupation') {
        this.occupationList = res.data.predefined_options.data;
        return this.occupationList;
      } else if (type == 'vnd_payment_mode') {
        this.vndPaymentModeList = res.data.predefined_options.data;
        return this.vndPaymentModeList;
      } else if (type == 'vnd_bank_name') {
        this.vndBankNameList = res.data.predefined_options.data;
        return this.vndBankNameList;
      } else if (type == 'cny_bank_name') {
        this.cnyBankNameList = res.data.predefined_options.data;
        return this.cnyBankNameList;
      } else if (type == 'vnd_district') {
        this.vndDistrictList = res.data.predefined_options.data;
        return this.vndDistrictList;
      }
      // return this.countryList;
    }
    return undefined;
    // this.coreService.getRequest(`misc/predefined-options`, param).subscribe({
    //   next: (res: any) => {
    //     console.log("get country list");
    //     console.log(res);
    //     const countryList: PredefinedOptions[] = res.data.predefined_options.data;
    //     return countryList;
    //   },
    //   error: (error: any) => {
    //     this.err = error;
    //     console.log(this.err);
    //     if (this.err?.errors == 'Unauthorized') {
    //       this.removeTokenAndLogout();
    //     }
    //   },
    // });
  }

  getVoucherTransactionType(voucherTransaction: VoucherTransaction) {
    if (voucherTransaction.voucher_category_snapshot === 'birthday') {
      return 'Birthday Voucher';
    } else if (
      voucherTransaction.voucher_category_snapshot === 'next_transaction'
    ) {
      return 'Next Transaction Voucher';
    } else if (
      voucherTransaction.voucher_category_snapshot === 'new_remitter'
    ) {
      return 'New Member Voucher';
    } else {
      let discountVoucherType = 'General';

      if (voucherTransaction.voucher_discount_type_snapshot === 'service') {
        discountVoucherType = 'Service Fee';
      }

      let voucherType = 'Fixed';

      if (voucherTransaction.voucher_type_snapshot === 'percentage') {
        voucherType = 'Percentage';
      } else if (voucherTransaction.voucher_type_snapshot === 'waived') {
        voucherType = 'Waiver';
      }

      return `${discountVoucherType} ${voucherType} Voucher`;
    }
  }

  async getMyInfoPassType(
    param: HttpParams
  ): Promise<MyInfoPassType[] | undefined> {
    const req = this.coreService.getRequest(`passtype/admin`, param);
    const res = await lastValueFrom(req);
    if (res.data) {
      this.passTypeList = res.data;
      console.log('getMyInfoPassType res');
      console.log(this.passTypeList);
      return this.passTypeList;
    }
    return undefined;
    // this.coreService.getRequest(`passtype/admin`).subscribe({
    //   next: (res: any) => {
    //     console.log(res);
    //     const passTypeList: MyInfoPassType[] = res.data;
    //     return passTypeList;
    //   },
    //   error: (error: any) => {
    //     this.err = error;
    //     console.log(this.err);
    //     if (this.err?.errors == 'Unauthorized') {
    //       this.removeTokenAndLogout();
    //     }
    //   },
    // });
  }

  async getSiteSetting(
    id: number,
    param?: HttpParams
  ): Promise<SiteSetting | undefined> {
    const req = this.coreService.getRequest(`site-setting/${id}`, param);
    const res = await lastValueFrom(req);
    if (res.data) {
      return res.data;
    }
    return undefined;
  }

  async getSiteSettingByTag(
    tag: string,
    param?: HttpParams
  ): Promise<SiteSetting | undefined> {
    const req = this.coreService.getRequest(`site-setting/tag/${tag}`, param);
    const res = await lastValueFrom(req);
    if (res.data) {
      return res.data;
    }
    return undefined;
  }

  async getCurrencyList(param: HttpParams): Promise<Currency[] | undefined> {
    const req = this.coreService.getRequest(`currency/admin`, param);
    const res = await lastValueFrom(req);
    if (res.data) {
      this.currencyList = res.data.currencies.data;
      return this.currencyList;
    }
    return undefined;
  }

  removeTokenAndLogout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_full_name');
    localStorage.removeItem('role_name');
    this.router.navigateByUrl('/');
  }

  viewDoc(api_call: string, fileName?: string) {
    if (fileName) {
      api_call = `${api_call}/${fileName}`;
    }
    this.coreService.downloadFile(api_call).subscribe();
  }

  onMatDatepickerChangeDate(
    event: MatDatepickerInputEvent<Date>,
    key: string,
    control: NgModel,
    obj: any
  ) {
    let errMsg = '';
    try {
      const date = event.value;
      if (!date || isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
      obj[key] = this.convertDateToStrYYYYMMDD(date);
      control.control.setErrors(null); // Clear previous errors if any
    } catch (error) {
      if (error instanceof Error) {
        errMsg = error.message;
        console.error(error.message); // Handle invalid date error
      } else {
        errMsg = 'An unexpected error occurred.';
        console.error('An unexpected error occurred.');
      }
      this.setControlError(control.control, 'invalidDate', errMsg);
    }
  }

  convertDateToStrYYYYMMDD(input: any): string {
    let date: Date;

    // Check if the input is already a Date object
    if (input instanceof Date) {
      date = input;
    } else {
      // Convert the input to a Date object
      date = new Date(input);
    }

    // Ensure the date is valid
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date');
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  setControlError(
    control: AbstractControl,
    errorName: string,
    errorValue: any
  ) {
    const errors = control.errors || {};
    errors[errorName] = errorValue;
    control.setErrors(errors);
  }

  capitalize(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  calculateIDByPage(curPage: number, pageSize: number, curIndex: number) {
    return (curPage - 1) * pageSize + (curIndex + 1);
  }
}
